var $a2ee270b31d6089b$exports = {};
$a2ee270b31d6089b$exports = {
    "loading": `L\xe4ser in...`,
    "loadingMore": `L\xe4ser in mer...`
};


export {$a2ee270b31d6089b$exports as default};
//# sourceMappingURL=sv-SE.mjs.map
